module.exports = __webpack_public_path__ + "img/drone-streefkerk-sunny.c08f5fb1.jpg";